import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { TONE_BADGE, TONE_DOT, type Tone } from '@/lib/status';

export function Badge({
  tone = 'neutral',
  children,
  className,
  size = 'sm',
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border font-semibold uppercase tracking-wide',
        size === 'sm' ? 'px-2 py-0.5 text-2xs' : 'px-2.5 py-1 text-xs',
        TONE_BADGE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Small status dot used in legends and inline labels. */
export function Dot({ tone, className }: { tone: Tone; className?: string }) {
  return <span className={cn('inline-block h-2 w-2 shrink-0 rounded-full', TONE_DOT[tone], className)} />;
}

/** "● Crítico (2)" style legend entry. */
export function LegendItem({ tone, label, count }: { tone: Tone; label: string; count?: number }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-ink-muted">
      <Dot tone={tone} />
      {label}
      {count != null && <span className="text-ink">({count})</span>}
    </span>
  );
}
